import React from 'react';
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';
import cNames from '../../Utility/utility';
import styles from '../../Assets/Styles/Components/Navbar/UserInfo.module.css';

class UserInfo extends React.Component {
	constructor(props) {
		super(props);
		this.state = { hide: true };
	}

	toggleDropDown = () => {
		this.setState((prev) => ({ hide: !prev.hide }));
	}

	onExit = () => {
		localStorage.setItem('token', '');
		this.props.history.push(`/login`);
	}

	render() {
		const { hide } = this.state;
		const { name, mobile } = this.props;
		return (
			<div className={styles.userInfo}>
				<div className={styles.title} onClick={this.toggleDropDown}>
					<i className={`${styles.down} fas fa-chevron-down ${hide ? '' : styles.active}`} />
					<span className={styles.name}>{this.props.profile && this.props.profile.profile && Object.keys(this.props.profile.profile).length !== 0 && this.props.profile.profile.display_name}</span>
					<i className={cNames(styles.userIcon, 'fal fa-user-circle')} />
				</div>
				<div className={`${styles.userInfoHide} ${hide ? '' : styles.userInfoShow}`}>
					<div className={styles.userInfo}>
						<i className={cNames(styles.infoIcon, 'fal fa-user-circle')} />
						<div className={styles.info}>
							<span>{this.props.profile && this.props.profile.profile && Object.keys(this.props.profile.profile).length !== 0 && this.props.profile.profile.display_name}</span>
							<br />
							<span>{this.props.profile && this.props.profile.profile && Object.keys(this.props.profile.profile).length !== 0 && this.props.profile.profile.mobile_number}</span>
						</div>
					</div>
					<a href="https://www.kadro.co/app/galleries/profile" className={styles.financeInfo}>
						<div className={styles.financeTitle}>
							<i className={cNames(styles.infoIcon, 'fas fa-user')} />
							<span>حساب کاربری</span>
						</div>
						<div className={styles.credit}>{this.props.profile && this.props.profile.profile && Object.keys(this.props.profile.profile).length !== 0 && new Intl.NumberFormat().format(this.props.profile.profile.balance)} تومان</div>
					</a>
					<hr className={styles.sep} />
					<div className={styles.exit} onClick={this.onExit}>
						<i className={cNames(styles.exitIcon, 'fal fa-sign-out-alt')} />
						<span>خروج</span>
					</div>
				</div>
			</div>
		);
	}
}
const mapStateToProps = (state) => {
	return {
		state,
		profile: state.profile,
	};
};
export default connect(mapStateToProps)(withRouter(UserInfo));
